// extracted by mini-css-extract-plugin
export default {"branchServiceSelect":"branchServiceSelect___yh4J3"};